import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/exam_questions/qb_question_types',
    name: 'qbQuestionTypes',
    component: () => import('@/views/question-bank/qb-question-type/Index.vue'),
    meta: {
      pageTitle: 'Danh sách loại câu hỏi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Loại câu hỏi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_QUESTION_TYPE,
    },
  },
  {
    path: '/exam_questions/qb_criteria_mix_exams',
    name: 'qbCriteriaMixExams',
    component: () => import('@/views/question-bank/qb-criteria-mix-exam/Index.vue'),
    meta: {
      pageTitle: 'Danh sách tiêu chí trộn đề thi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Tiêu chí trộn đề thi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_CRITERIA_MIX_EXAM,
    },
  },
  {
    path: '/exam_questions/qb_question_scales',
    name: 'qbQuestionScales',
    component: () => import('@/views/question-bank/qb-question-scale/Index.vue'),
    meta: {
      pageTitle: 'Mức độ câu hỏi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Mức độ câu hỏi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_QUESTION_SCALE,
    },
  },
  {
    path: '/exam_questions/qb_questions',
    name: 'qbQuestions',
    component: () => import('@/views/question-bank/qb-question/Index.vue'),
    meta: {
      pageTitle: 'Ngân hàng câu hỏi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Ngân hàng câu hỏi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_QUESTION,
    },
  },
  {
    path: '/exam_questions/qb_exam_structures',
    name: 'qbExamStructures',
    component: () => import('@/views/question-bank/qb-exam-structure/Index.vue'),
    meta: {
      pageTitle: 'Cấu trúc đề thi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Cấu trúc đề thi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_EXAM_STRUCTURE,
    },
  },
  {
    path: '/exam_questions/qb_exams',
    name: 'qbExams',
    component: () => import('@/views/question-bank/qb-exam/Index.vue'),
    meta: {
      pageTitle: 'Dự thảo đề thi',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Dự thảo đề thi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_EXAM,
    },
  },
  {
    path: '/exam_questions/qb_exam_course_semesters',
    name: 'qbExamCourseSemesters',
    component: () => import('@/views/question-bank/qb-exam-course-semester/QbExamCourseSemester.vue'),
    meta: {
      pageTitle: 'Quản lý đề thi trong học kỳ',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Quản lý đề thi trong học kỳ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_EXAM_COURSE_SEMESTER,
    },
  },
  {
    path: '/exam_questions/qb_exam_course_semester_proclaimed',
    name: 'qbExamCourseSemesterProclaimed',
    component: () => import('@/views/question-bank/qb-exam-course-semester-proclaimed/QbExamCourseSemesterProclaimed.vue'),
    meta: {
      pageTitle: 'Quản lý đề thi được công bố',
      breadcrumb: [
        {
          text: 'Quản lý đề thi',
          active: false,
        },
        {
          text: 'Quản lý đề thi được công bố',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.QB_EXAM_COURSE_SEMESTER_PROCLAIMED,
    },
  },
]
